goog.provide('el8.practicedata.recurringEventSchedules');

goog.require('el8.model.base');
goog.require('el8.data.practiceUsers');

el8.practicedata.recurringEventSchedules = (function() {

    var _class = function(spec) { this.populate(spec); };
    _class.inheritsFrom(el8_Entity);

    _class.addIntProperty('eventGroupId', true);
    _class.addDate('seriesStart', true);
    _class.addDate('seriesStop', true);

    _class.addTime('eventTime', true);
    _class.addIntProperty('eventDuration', true);

    _class.addProperty('daysOfWeek', true, []);  // array for 0=Sunday, 1=Monday..., 6=Sunday
    _class.addStringProperty('repeats', true);

    _class.addStringProperty('description', true);
    _class.addIntProperty('physicianUserId', true);
    _class.addIntProperty('truePhysicianUserId', true);

    /** Only for saving, in case this is replacing an existing time block **/
    _class.addIntProperty('replacedApptId');
    /** Only for saving, in case is changing information **/
    _class.addBoolean('repeatsChanged');
    _class.addBoolean('eventChanged');

    _class.addIntProperty('practiceId', true);
    _class.addStringProperty('practiceName', true);
    _class.addIntProperty('apptTypeId', true);
    _class.addIntProperty('timeSlotType', true);
    _class.addIntProperty('timeSlotStatus', true);
    
    _class.prototype.getPhysicianUserFullName = function() {
        if (this.getPhysicianUserId()) {
            var user = el8.data.practiceUsers.getById(this.getPhysicianUserId());
            return user ? user.getFullName() : '';
        } else {
            return 'all physicians';
        }
    };
    
    _class.prototype.isWeeklyRepeat = function() {
        return this.getRepeats() === 'weekly';
    };
    _class.prototype.isMonthlyRepeat = function() {
        return this.getRepeats() === 'monthly';
    };
    _class.prototype.isAllPhysicians = function() {
        return !this.getPhysicianUserId();
    };
    _class.prototype.getSeriesLastDate = function() {
        if (this.getSeriesStop()) {
            var lastDate = el8.service.tz.newTzDate(this.getSeriesStop()).addDays(-1);
            return lastDate;
        }
        return null;
    };
    _class.prototype.pertainsToRange = function(startDate, endDate) {
        // note that this doesn't guarantee an event exists; simply that it may exist
        if (!endDate) { endDate = el8.service.tz.newTzDate(startDate); }

        if (this.getSeriesStop()) {
            var lastDay = this.getSeriesLastDate();
            // http://stackoverflow.com/questions/325933/determine-whether-two-date-ranges-overlap
            return (Math.max(startDate.getTime(), this.getSeriesStart().getTime()) <=
                Math.min(endDate.getTime(), lastDay.getTime()));
        } else {
            return endDate.getTime() >= this.getSeriesStart();
        }
    };
    _class.prototype.pertainsToDate = function(_date) {
        return this.pertainsToRange(_date) && this.getDaysOfWeek()[_date.getDay()] &&
            (this.isWeeklyRepeat() || 
             (this.isMonthlyRepeat() &&
              (el8.util.datecompare.getWeekOfMonth(this.getSeriesStart()) ===
               el8.util.datecompare.getWeekOfMonth(_date))));
    };
    _class.prototype.getFirstEventDate = function() {
        if (this.pertainsToDate(this.getSeriesStart())) {
            return el8.service.tz.newTzDate(this.getSeriesStart());
        } else {
            return this.getNextEventDate(this.getSeriesStart());
        }
    };
    _class.prototype.getNextEventDate = function(_date) {
        // Since we're at most looking forward 30 days, this seems
        // like the simplest implementation for now, using existing infra
        var currDate = el8.service.tz.newTzDate(_date);
        if (this.getSeriesLastDate()) {
            while(currDate.getTime() < this.getSeriesLastDate().getTime()) {
                currDate.addDays(1);
                if (this.pertainsToDate(currDate)) {
                    return currDate;
                }
            }
        } else {
            while(true) {
                currDate.addDays(1);
                if (this.pertainsToDate(currDate)) {
                    return currDate;
                }
            }
        }
        return null
    };
    _class.prototype.scheduleVirtualEvents = function(startDate, endDate, rawJson) {
        if (!endDate) { endDate = el8.service.tz.newTzDate(startDate); }
        var result = [];
        if (this.pertainsToRange(startDate, endDate)) {
            var currDate = startDate;
            while(currDate.getTime() <= endDate.getTime()) {  // endDate inclusive
                var virtualEvent = this.scheduleVirtualEvent(currDate, rawJson);
                if (virtualEvent) { result.push(virtualEvent); }
                currDate.addDays(1);
            }
        }
        return result;
    };
    _class.prototype.scheduleVirtualEvent = function(_date, rawJson) {
        var currDate = el8.service.tz.newTzDate(_date);
        if (!this.pertainsToDate(currDate)) {
            return null;
        }
        var apptTime;
        if (
            el8Globals.FEATURES.Workspaces &&
            el8Globals.PRIMARY_PRACTICE_LOCALE !== el8Globals.PRACTICE_LOCALE
          ) {
            apptTime = el8.service.tz.newPrimaryPracticeTzDateTime(
                _date.getFullYear(),
                _date.getMonth(),
                _date.getDate(),
                this.getEventTime().getHours(),
                this.getEventTime().getMinutes(),
                this.getEventTime().getSeconds(),
                el8Globals.PRIMARY_PRACTICE_LOCALE
            );
        } else {
            apptTime = el8.service.tz.newTzDateTime(
                _date.getFullYear(),
                _date.getMonth(),
                _date.getDate(),
                this.getEventTime().getHours(),
                this.getEventTime().getMinutes(),
                this.getEventTime().getSeconds()
            );
        }
        var data = {
            appt_time: apptTime,
            recurring_id: this.getId(),
            duration: this.getEventDuration(),
            description: this.getDescription(),
            physician_user_id: this.getPhysicianUserId(),
            true_physician_user_id: this.getTruePhysicianUserId()
        }
        
        if (rawJson) { return data; }
        else { return new _VirtualEventClass(data); }
    };
    _class.prototype.asMap = function() {
        return el8_Entity.prototype.asMap.call(this, true);
    };

    var _VirtualEventClass = (function() {
        var _virtualClass = function(spec) { this.populate(spec); };
        _virtualClass.inheritsFrom(el8_Entity);
        _virtualClass.prototype.populate = function(spec) {
            spec = spec || {};
            spec['model_class'] = 'VirtualEvent';
            this.parent.populate.call(this, spec);
        };
        _virtualClass.addIntProperty('recurringId');
        _virtualClass.addDateTime('apptTime');
        _virtualClass.addIntProperty('duration');
        _virtualClass.addStringProperty('description');
        _virtualClass.addIntProperty('physicianUserId');
        _virtualClass.addIntProperty('truePhysicianUserId');
        _virtualClass.prototype.getEndApptTime = function() {
            var endApptTime = el8.service.tz.newTzDateTime(this.getApptTime());
            return endApptTime.addMinutes(this.getDuration());
        };
        _virtualClass.prototype.getStartTime = function() {
            return el8.service.tz.newTzTime(
                    this.getApptTime().getHours(), this.getApptTime().getMinutes(),
                    this.getApptTime().getSeconds(), this.getApptTime().getMilliseconds());
        };
        _virtualClass.prototype.getEndTime = function() {
            return this.getStartTime().addMinutes(this.getDuration());
        };
        _virtualClass.prototype.getId = function() {
            return this.getVirtualId();
        };
        _virtualClass.prototype.getVirtualId = function() {
            return this.getRecurringId()+'_'+el8.service.tz.asDateStr(this.getApptTime());
        };
        _virtualClass.prototype.getRecurring = function() {
            return el8.practicedata.recurringEventSchedules.getById(this.getRecurringId());
        };
        // these are utility functions provided by el8.practicedata.appts, replicated here
        // note that while this could support appt slot and other events, the backend would
        // only have recurring other events, because we materialize the recurring appt slot
        _virtualClass.prototype.isAppointment = function() {
            return false;
        };
        _virtualClass.prototype.isAppointmentSlot = function() {
            return this.getRecurring().getTimeSlotType() === 3; 
        };
        _virtualClass.prototype.isTimeBlock = function() {
            return this.getRecurring().getTimeSlotType() === 2;
        };
        _virtualClass.prototype.isOpenSlot = function() {
            return this.getRecurring().getTimeSlotType() === 3; 
        };
        _virtualClass.prototype.isFilledSlot = function() {
            return false;
        };
        _virtualClass.prototype.getApptTypeId = function() {
            var recurring = this.getRecurring();
            return recurring.getApptTypeId();
        };
        // making this match el8.practice.data.appts, this is
        // being used more by the react XO scheduler
        _virtualClass.prototype.asMap = function() {
            var m = {};
            m['model_class'] = 'VirtualEvent';
            m['id'] = this.getVirtualId();
            m['patient_id'] = null;
            m['patient_name'] = '';
            m['appt_time'] = el8.service.tz.asServerFormatDateTime(this.getApptTime());
            m['appt_type_id'] = null;
            m['duration'] = this.getDuration();
            m['time_slot_type'] = this.getRecurring().getTimeSlotType();
            m['time_slot_status'] = null;
            m['description'] = this.getDescription();
            m['physician_user_id'] = this.getPhysicianUserId();
            m['true_physician_user_id'] = this.getTruePhysicianUserId();
            m['recurring_id'] = this.getRecurringId();
            m['practice_id'] = this.getRecurring().getPracticeId();
            m['practice_name'] = this.getRecurring().getPracticeName();
            return m;
        };
        _virtualClass.prototype.asSoyMap = function() {
            var m = {};
            m['isBooked'] = true;
            m['isTimeBlock'] = true;
            m['id'] = this.getVirtualId();
            m['startTime'] = this.getStartTime().asTimeString();
            m['endTime'] = this.getEndTime().asTimeString();
            m['startTimeShort'] = this.getStartTime().asShortTimeString();
            m['endTimeShort'] = this.getEndTime().asShortTimeString();
            m['description'] = this.getDescription();
            m['physicianUserId'] = this.getPhysicianUserId();
            m['truePhysicianUserId'] = this.getTruePhysicianUserId();
            return m;
        };
        return _virtualClass;
    })();

    var that = new el8_EntitySet({
        model: function(spec) { return new _class(spec); },
        urlFn: function(id) { return el8.service.urls.get('recurringEvent', [id]); },
        saveFn: function(item, successCb, errorCb, opts) {
            opts = opts || {};
            var map = item.asMap();
            var replacedApptId = item.getReplacedApptId();
            if (replacedApptId) {
                map['replaced_appt_id'] = replacedApptId;
            }
            $.el8_ajax({
                type: 'POST',
                url: el8.service.urls.get('recurringEvent', item.getId() ? [item.getId()] : null),
                data: JSON.stringify(map),
                async: opts.async,
                success: function(data) {
                    if (replacedApptId) {
                        var removed = el8.practicedata.appts.remove(replacedApptId);
                        that.trigger('LOCAL_DELETE', removed);
                    }
                    if (data['existing_schedule']) {
                        item.populate(data['existing_schedule']);
                        that.trigger('LOCAL_UPDATE', item, opts.oldItem);
                    }
                    if (data['new_schedule']) { 
                        var newSchedule = that.create(data['new_schedule']); 
                        that.trigger('LOCAL_UPDATE', newSchedule);
                    }
                    if (successCb) { successCb(data); }
                },
                error: errorCb
            });
        }
    });

    that.deleteSingleEvent = function(recurring, eventDate, successCb, errorCb) {
        var params = '?series_stop='+el8.service.tz.asUrlFormatDate(eventDate);
        var nextEventDate = recurring.getNextEventDate(eventDate);
        if (nextEventDate) {
            params += '&new_series_start='+el8.service.tz.asUrlFormatDate(nextEventDate);
        }

        if (recurring.getTimeSlotType() === 3) {
            el8.appservice.notifier.notify('Deleting appointment slot...' );
        } else {
            el8.appservice.notifier.notify('Deleting event...' );
        }

        $.el8_ajax({
            type: 'DELETE',
            url: el8.service.urls.get('recurringEvent', [recurring.getId()]) + params,
            success: function(data) {
                if (recurring.getTimeSlotType() === 3) {
                    el8.appservice.notifier.notify('Appointment slot deleted' );
                } else {
                    el8.appservice.notifier.notify('Event deleted' );
                }

                if (data['existing_schedule']) { 
                    var existingSchedule = that.create(data['existing_schedule']); 
                    that.trigger('LOCAL_UPDATE', existingSchedule);
                }
                if (data['new_schedule']) { 
                    var newSchedule = that.create(data['new_schedule']); 
                    that.trigger('LOCAL_UPDATE', newSchedule);
                }
                that.trigger('LOCAL_UPDATE', recurring);
                if (successCb) { successCb(data); }
            },
            errorCb: function() {
                if (errorCb) { successCb(); }
            }
        });
    };

    that.deleteEventOnward = function(recurring, eventDate, successCb, errorCb) {
        var params = '?series_stop='+el8.service.tz.asUrlFormatDate(eventDate);

        if (recurring.getTimeSlotType() === 3) {
            el8.appservice.notifier.notify('Deleting recurring appointment slot...' );
        } else {
            el8.appservice.notifier.notify('Deleting recurring event...' );
        }

        $.el8_ajax({
            type: 'DELETE',
            url: el8.service.urls.get('recurringEvent', [recurring.getId()]) + params,
            success: function(data) {
                if (recurring.getTimeSlotType() === 3) {
                    el8.appservice.notifier.notify('Recurring appointment slots deleted' );
                } else {
                    el8.appservice.notifier.notify('Recurring events deleted' );
                }

                if (data['existing_schedule']) {
                    var existingSchedule = that.create(data['existing_schedule']); 
                    that.trigger('LOCAL_UPDATE', existingSchedule);
                }
                that.trigger('LOCAL_UPDATE', recurring);
                if (successCb) { successCb(data); }
            },
            errorCb: function() {
                if (errorCb) { successCb(); }
            }
        });
    };

    that.getByPhysicianUserIdAndDate = function(physicianUserId, _date) {
        // Just do brute force because don't expect TOO many of these
        return that.all().filter(function(a) {
            return a.pertainsToDate(_date) &&
                (!a.getPhysicianUserId() || (a.getPhysicianUserId() === physicianUserId));
        });
    };

    return that;

})();

